export default __webpack_public_path__ + "static/media/harvardLogo.542dab89.png";